import {
  Grid,
  Image,
  Title,
  Text,
  Container,
  Box,
  Button,
} from "@mantine/core";
import { Link } from "react-router-dom";

export function ClientLogosSection({
  logos,
  title = "Trusted by Industry Pioneers",
  description = "A legacy of excellence, globally recognized and trusted by top organizations worldwide",
  columns = { base: 6, xs: 4, md: 3, lg: 2 },
  imageHeight = 80,
  link = "",
}) {
  return (
    <Container size="lg" py="xl" my="xl">
      {/* Header Section */}
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <Title order={2} size="h2" mb="sm">
          {title}
        </Title>
        <Text
          size="lg"
          style={{ fontSize: "1.1rem", maxWidth: 800, margin: "0 auto" }}
        >
          {description}
        </Text>
      </div>

      {/* Logos Grid */}
      <Grid justify="center" align="center">
        {logos.map((logo) => (
          <Grid.Col
            key={logo.id}
            span={{
              base: columns.base || 6,
              xs: columns.xs || 4,
              md: columns.md || 3,
              lg: columns.lg || 2,
            }}
          >
            <Image
              src={logo.src}
              alt={logo.alt}
              fit="contain"
              height={imageHeight}
            />
          </Grid.Col>
        ))}
      </Grid>
      <Box mt="xl">
        <Link to={link}>
          <Button>Read More</Button>
        </Link>
      </Box>
    </Container>
  );
}
